import { render, staticRenderFns } from "./ButtonSelector.vue?vue&type=template&id=605127bb&scoped=true&"
import script from "./ButtonSelector.vue?vue&type=script&lang=js&"
export * from "./ButtonSelector.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSelector.vue?vue&type=style&index=0&id=605127bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605127bb",
  null
  
)

export default component.exports